'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from 'lucide-react'

import { cn } from '@strata-monorepo/shared-ui/utils/cn'

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      className={cn(
        'peer strata:border-input strata:dark:bg-input/30 strata:data-[state=checked]:bg-primary strata:data-[state=checked]:text-primary-foreground strata:dark:data-[state=checked]:bg-primary strata:data-[state=checked]:border-primary strata:focus-visible:border-ring strata:focus-visible:ring-ring/50 strata:aria-invalid:ring-destructive/20 strata:dark:aria-invalid:ring-destructive/40 strata:aria-invalid:border-destructive strata:size-4 strata:shrink-0 strata:rounded-[4px] strata:border strata:shadow-xs strata:transition-shadow strata:outline-none strata:focus-visible:ring-[3px] strata:disabled:cursor-not-allowed strata:disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        className='strata:flex strata:items-center strata:justify-center strata:text-current strata:transition-none'
      >
        <CheckIcon className='strata:size-3.5' />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
